import { taskTemplatesService } from '@/services/task-templates.service';

const initialState = () => ({
  taskTemplates: [],
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getTaskTemplates({ commit }) {
    commit('GET_TASK_TEMPLATES');
    return taskTemplatesService.getTaskTemplates().then(
      (taskTemplates) => {
        commit('GET_TASK_TEMPLATES_SUCCESS', taskTemplates);
        return taskTemplates;
      },
      (error) => {
        commit('GET_TASK_TEMPLATES_ERROR', error);
        throw error;
      },
    );
  },
  createTaskTemplate({ commit }, data) {
    commit('CREATE_TASK_TEMPLATE');
    return taskTemplatesService.createTaskTemplate(data).then(
      (created) => {
        commit('CREATE_TASK_TEMPLATE_SUCCESS', created);
        return created;
      },
      (error) => {
        commit('CREATE_TASK_TEMPLATE_ERROR', error);
        throw error;
      },
    );
  },
  updateTaskTemplate({ commit }, data) {
    commit('UPDATE_TASK_TEMPLATE');
    return taskTemplatesService.updateTaskTemplate(data).then(
      (updated) => {
        commit('UPDATE_TASK_TEMPLATE_SUCCESS', updated);
        return updated;
      },
      (error) => {
        commit('UPDATE_TASK_TEMPLATE_ERROR', error);
        throw error;
      },
    );
  },
  deleteTaskTemplate({ commit }, id) {
    commit('DELETE_TASK_TEMPLATE');
    return taskTemplatesService.deleteTaskTemplate(id).then(
      () => {
        commit('DELETE_TASK_TEMPLATE_SUCCESS', id);
      },
      (error) => {
        commit('DELETE_TASK_TEMPLATE_ERROR', error);
        throw error;
      },
    );
  },
  RESET({ commit }) {
    commit('RESET_STORE');
  },
};

const mutations = {
  // The list stays shown until the new one replaces it.
  GET_TASK_TEMPLATES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  GET_TASK_TEMPLATES_SUCCESS(state, taskTemplates) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.taskTemplates = (taskTemplates || []).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  },
  GET_TASK_TEMPLATES_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error,
    };
    state.taskTemplates = [];
  },
  CREATE_TASK_TEMPLATE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  CREATE_TASK_TEMPLATE_SUCCESS(state, createdTaskTemplate) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.taskTemplates = [...state.taskTemplates, createdTaskTemplate];
  },
  CREATE_TASK_TEMPLATE_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error,
    };
  },
  UPDATE_TASK_TEMPLATE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  UPDATE_TASK_TEMPLATE_SUCCESS(state, updatedTaskTemplate) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };

    state.taskTemplates = state.taskTemplates.map((t) => {
      if (t.id === updatedTaskTemplate.id) {
        return updatedTaskTemplate;
      }
      return t;
    });
  },
  UPDATE_TASK_TEMPLATE_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error,
    };
  },
  DELETE_TASK_TEMPLATE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  DELETE_TASK_TEMPLATE_SUCCESS(state, id) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.taskTemplates = state.taskTemplates.filter((t) => t.id !== id);
  },
  DELETE_TASK_TEMPLATE_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error,
    };
  },
  RESET_STORE(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  taskTemplates: (state) => state.taskTemplates,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const taskTemplates = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
